<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Procesos automáticos</h2>
      </div>
    </div>
  </section>
  <section class="section py-1" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </section>
  <section class="section py-1" *ngIf="!isLoading">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            <div class="table-jobs" *ngIf="jobs">
              <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="jobs" (onSelectRow)="goToDetail($event)"></app-generic-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  